import { ApiErrorLike } from '../components/interfaces';

const fallbackMessage = 'Something went wrong. Please try again.';

const stockMessagesToPreserve = [
  /^Only \d+ item\(s\) available/i,
  /.+ is out of stock\.?$/i,
  /.+ is not currently available\.?$/i,
  /^Please select a size for .+/i,
];

const formatStockMessage = (rawMessage: string) => {
  const match = rawMessage.match(/^Only (\d+) item\(s\) available in stock for (.+?)\.?$/i);
  if (!match) return rawMessage;

  const [, quantity, variant] = match;
  return `Only ${quantity} ${Number(quantity) === 1 ? 'item is' : 'items are'} available for ${variant}.`;
};

const userSafeMessages: Array<[RegExp, string]> = [
  [/not authenticated|access denied|forbidden|unauthorized/i, 'You do not have permission to perform this action.'],
  [/network|failed to fetch/i, 'Network error. Check your connection and try again.'],
  [/validation/i, 'Please review the highlighted fields and try again.'],
];

export const getApiErrorMessage = (error: unknown, fallback = fallbackMessage) => {
  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  const apiError = error as ApiErrorLike;
  const rawMessage =
    apiError?.response?.errors?.[0]?.message ||
    apiError?.message ||
    fallback;

  if (stockMessagesToPreserve.some((pattern) => pattern.test(rawMessage))) {
    return formatStockMessage(rawMessage);
  }

  const mapped = userSafeMessages.find(([pattern]) => pattern.test(rawMessage));

  return mapped?.[1] || rawMessage || fallback;
};

export const logApiError = (context: string, error: unknown) => {
  if (process.env.NODE_ENV === 'production') {
    console.error(context, getApiErrorMessage(error));
    return;
  }

  console.error(context, error);
};
